import type { FieldErrors } from 'react-hook-form';

/**
 * Validates whether a react-hook-form Form is validated and whether it has errors.
 *
 * This differs from formState.isValid which just checks for client-side validation success.
 */
export function checkIsFormValid(errors: FieldErrors) {
  return Object.keys(errors).length === 0;
}
